import { useState } from 'react';
import { Path } from '../Path';
import { Position } from '../../../../../../types';
import PathSelection from '../PathSelection';
import PathRenderer from '../PathRenderer';
import { PathsWrapper } from './RenderPaths.styled';
import { useZoneContext } from 'context/ZoneContext';

type RenderPathsProps = {
    paths: Path[];
    selectedPath?: Path;
};
/**
 * This component renders paths
 * All paths rendered in a single svg. We wanted to show already traversed paths / selected path in a high zIndex
 * But we don't have any zIndex for SVG g/path item. so rendering traversed paths at the end to show them on top of other paths if they are crossing each other in any place
 * - First we will render all paths which will finds and stores path points (so no change even it drawn on top)
 * - Then draws traversed paths / selected path on top again
 */
export const RenderPaths = ({ paths, selectedPath }: RenderPathsProps) => {
    const [mousePosition, setMousePosition] = useState<Position>();
    const { scale } = useZoneContext();
    const handleClick = (e: React.MouseEvent<SVGElement>) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const x = (e.clientX - rect.left) / scale;
        const y = (e.clientY - rect.top) / scale;

        setMousePosition({ x, y });
    };

    return (
        <>
            <PathsWrapper onClick={handleClick} id="paths-wrapper">
                {paths.map(path => (
                    <PathRenderer key={path.getId()} path={path} />
                ))}
                {paths
                    .filter(({ isSelected }) => isSelected === null)
                    .map(path => (
                        <PathRenderer key={path.getId() + '-to-be-traversed'} path={path} />
                    ))}
                {paths
                    .filter(({ isSelected }) => isSelected)
                    .map(path => (
                        <PathRenderer key={path.getId() + '-traversed'} path={path} />
                    ))}
                {selectedPath && <PathRenderer key={selectedPath.getId() + 'selected'} path={selectedPath} />}
            </PathsWrapper>
            {selectedPath && mousePosition ? <PathSelection mousePosition={mousePosition} /> : null}
        </>
    );
};
